import {Component} from '@angular/core';
import {FileUpload, FileUploadHandlerEvent} from 'primeng/fileupload';
import {
  CustomerClient,
  DocumentDto,
  DocumentType,
  PetClient,
  TreatmentClient
} from '../../../api/api-client';
import {DialogService, DynamicDialogModule, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslationPipe} from '../../../pipes/translation.pipe';

import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {CheckboxModule} from 'primeng/checkbox';
import {ButtonModule} from 'primeng/button';
import {AddDocumentRoutingInfo} from '../../../models/add-document-routing-info';
import {Router} from '@angular/router';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {SubscriptionManager} from '../../../services/subscription-manager.service';


@Component({
  selector: 'app-add-document-dialog',
  imports: [
    FileUpload,
    TranslationPipe,
    ReactiveFormsModule,
    InputText,
    CheckboxModule,
    ButtonModule,
    DynamicDialogModule,
  ],
  providers: [SubscriptionManager],
  templateUrl: './add-document-dialog.component.html',
  styleUrl: './add-document-dialog.component.scss'
})
export class AddDocumentDialogComponent {

  pdfUrl!:SafeResourceUrl;
  routingData!: AddDocumentRoutingInfo;
  createDocumentForm = new FormGroup({
    id: new FormControl(''),
    base64Data: new FormControl("", {nonNullable: true}),
    mimeType: new FormControl("", {nonNullable: true}),
    isPinned: new FormControl(false, {nonNullable: true}),
    documentType: new FormControl<DocumentType>('Unknown', {nonNullable: true}),
    filename: new FormControl("", {nonNullable: true}),
  });

  constructor(
    private readonly subscriptionManager: SubscriptionManager,
    public ref: DynamicDialogRef,
    private readonly dialogService: DialogService,
    private readonly petClient: PetClient,
    private readonly treatmentClient: TreatmentClient,
    private readonly customerClient: CustomerClient,
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer
  ) {
    this.routingData = <AddDocumentRoutingInfo>this.dialogService.getInstance(this.ref)?.data;
  }


  addImage($event: FileUploadHandlerEvent) {
    for (const element of $event.files) {
      let mimeType = element.type;
      let filename = element.name;
      let reader = new FileReader();
      reader.onload = () => {
        const buffer = reader.result as ArrayBuffer;
        if (this.routingData.documentType == 'Document') {
          const blob = new Blob([buffer], { type: 'application/pdf' });

          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        }
        this.createDocumentForm.patchValue({
          mimeType: mimeType,
          filename: filename,
          base64Data: this.arrayBufferToBase64(buffer as unknown as Uint8Array),
          documentType: this.routingData.documentType
        })
      }
      reader.readAsArrayBuffer(element);
    }
  }

  onSubmit(shouldOpenPictureAnnotation: boolean) {
    switch (shouldOpenPictureAnnotation) {
      case false:
        switch (this.routingData.sourcePage) {
          case "pet-detail":
            if (this.routingData.isSkeleton) {
              console.error("THIS SHOULD NOT HAPPEN")
            } else {
              this.subscriptionManager.call(
                this.petClient.addDocumentToPet(this.routingData.entityId, <DocumentDto>this.createDocumentForm.value),
                (x => {
                  if (x.status == 201) {
                    this.ref.close();
                  }
                })
              );
            }
            break;
          case "treatment-detail":
            this.subscriptionManager.call(
              this.treatmentClient.addDocumentToTreatment(this.routingData.entityId, <DocumentDto>this.createDocumentForm.value),
              (x => {
                if (x.status == 201) {
                  this.ref.close();
                }
              })
            );
            break;
          case "customer-detail":
            this.subscriptionManager.call(
              this.customerClient.addDocumentToCustomer(this.routingData.entityId, <DocumentDto>this.createDocumentForm.value),
              (x => {
                if (x.status == 201) {
                  this.ref.close();
                }
              })
            );
            break;
        }
        break;
      case true:
        switch (this.routingData.sourcePage) {
          case "pet-detail":
            if (this.routingData.isSkeleton) {
              console.error("THIS SHOULD NOT HAPPEN")
            } else {
              this.subscriptionManager.call(
                this.petClient.addDocumentToPet(this.routingData.entityId, <DocumentDto>this.createDocumentForm.value),
                (x => {
                  if (x.status == 201) {
                    this.ref.close();
                    this.createDocumentForm.patchValue({id: x.result.id})
                    this.router.navigate(['../loggedin/images/annotate'], {
                      state: {
                        routingData: this.routingData,
                        addedDocument: <DocumentDto>this.createDocumentForm.value
                      }
                    });
                  }
                })
              );
            }
            break;
          case "treatment-detail":

            break;
          case "customer-detail":

            break;
        }
        break;
      default:
        break;
    }
  }

  determinePossibleMimeTypes() {
    switch (this.routingData.documentType) {
      case "Document":
        return ".pdf";
      case "Image":
        return "image/*,.dcm,";
      default:
        return "";
    }
  }

  private arrayBufferToBase64(buffer: Uint8Array) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return globalThis.btoa(binary);
  }

  public base64ToUint8Array(base64String: string): Uint8Array {
    const binaryString = atob(base64String);
    const byteArray = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = <number>binaryString.codePointAt(i);
    }

    return byteArray;
  }

  sanitizeResourceString(value: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  protected readonly Uint8Array = Uint8Array;
}
